import script from "./SystemMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SystemMessage.vue?vue&type=script&lang=ts&setup=true"

import "./SystemMessage.vue?vue&type=style&index=0&id=43aa1b8a&lang=scss"

const __exports__ = script;

export default __exports__